/* ═══════════════════════════════════════════════════════════════════════
   L'ÉTAT VIDE DU MODÈLE

   Une pastille ronde de 52 px, un titre de 15 px en 600, une phrase de
   13 px en gris — et rien d'autre. Pas de grande icône délavée : à
   12 pixels d'opacité 40 %, elle se lisait comme un défaut de
   chargement plutôt que comme une réponse.

   Deux lignes, jamais une : la première dit ce qui manque, la seconde
   ce qu'on peut y faire. « Aucune ressource » laisse la personne
   devant un écran vide ; « Aucune ressource — ajoutez-en une avec le
   bouton ci-dessus » lui donne la suite.
   ═══════════════════════════════════════════════════════════════════════ */

export default function EtatVide({ icone: Icone, titre, aide, action, className = '' }) {
  return (
    <div className={`px-5 py-12 text-center ${className}`}>
      {Icone && (
        <span className="w-[52px] h-[52px] mx-auto mb-3 rounded-controle grid place-items-center
                         bg-[var(--bg-main)] text-[var(--text-muted)]">
          <Icone className="w-6 h-6" strokeWidth={1.6} />
        </span>
      )}
      <p className="m-0 text-[15px] font-semibold text-[var(--text-bold)]">{titre}</p>
      {aide && (
        <p className="mt-1 text-[13px] text-[var(--text-muted)] max-w-sm mx-auto">{aide}</p>
      )}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
